import { render, staticRenderFns } from "./StatsWidget.vue?vue&type=template&id=7785d0c4&scoped=true&"
import script from "./StatsWidget.vue?vue&type=script&lang=js&"
export * from "./StatsWidget.vue?vue&type=script&lang=js&"
import style0 from "./StatsWidget.vue?vue&type=style&index=0&id=7785d0c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7785d0c4",
  null
  
)

export default component.exports